import { APIHelper } from '@/services/axios';

const getServices = brand => APIHelper.get('/services', { params: { brand } });

export { getServices };
